import Modal from "@components/modals/Modal";
import useGlobalContext from "@src/globalContext/hooks/useGlobalContext";
import { useState } from "react";
import RegisterContextProvider from "./context/RegisterContextProvider";
import RegisterInner from "./RegisterInner";

const RegisterModal = () => {
  const { authModal, setAuthModal } = useGlobalContext();

  const [step, setStep] = useState<number>(0);

  const active = authModal.type === "register";
  const close = () => setAuthModal(null);

  return (
    <Modal
      active={active}
      onClose={close}
      onlyCloseButton
      askBeforeClosing={step > 0}
      askModalProps={{
        title: "Registration Incomplete!",
        subTitle: "Your registration isn't complete, are you sure you want to leave?",
        cancelButtonText: "Stay",
        confirmButtonText: "Leave",
      }}
      id="register-modal"
      className="auth-modal">
      <RegisterContextProvider onStepChange={setStep}>
        <RegisterInner />
      </RegisterContextProvider>
    </Modal>
  );
};

export default RegisterModal;
